import { render, staticRenderFns } from "./uploads.vue?vue&type=template&id=3f832b9a"
import script from "./uploads.vue?vue&type=script&lang=js"
export * from "./uploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports